<template>
  <div class="chart-content">
    <!-- :key force the component to reload when the series change (I had an issue where echarts was not picking up some changes)-->
    <vue-echarts
      :key="chartKey"
      :ref="templateRef"
      :class="{ big: isFullscreen }"
      :option="chartOptions"
      :theme="theme"
      :autoresize="true"
      :style="`margin-top: ${marginTop};`"
      @rendered="chartRendered" />
  </div>
</template>

<script setup lang="ts">
  import { type EChartsOption, type SeriesOption } from 'echarts';
  import { computed } from 'vue';

  interface IProps {
    chartOptions: EChartsOption | null;
    isFullscreen: boolean;
    templateRef: string | null;
    theme: string | null;
    marginTop: string;
  }

  const props = defineProps<IProps>();

  const emit = defineEmits(['rendered']);

  const chartSeries = computed(() =>
    props.chartOptions?.series != null
      ? props.chartOptions?.series instanceof Array
        ? [props.chartOptions?.series as SeriesOption]
        : (props.chartOptions?.series as SeriesOption[])
      : [],
  );

  const chartKey = computed(() => chartSeries.value.length);

  const chartRendered = () => {
    emit('rendered');
  };
</script>

<style lang="scss" scoped>
  .chart-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: relative;
    margin-top: 1rem;
    overflow: hidden;

    .echarts {
      min-height: 27.2rem;
      height: 100%;
      width: 100%;

      &.big {
        min-height: 40vh;
      }
    }
  }
</style>
